import React, { useCallback } from "react";
import styles from "./chartBySla.module.scss";
import { Col, Row } from "react-bootstrap";
import { ReactComponent as CurrentLocation } from "../../../../../../assets/images/driver/current-location.svg";
import { FiPackage } from "react-icons/fi";
import moment from "moment";

const ChartBySla = ({ data }) => {
  const handleRedirect = useCallback((value, label) => {

    // const initialDateFormated = moment(data.startDate).format('DD/MM/YYYY');
    // const finalDateFormated = moment(data.endDate).format('DD/MM/YYYY');

    let path = `/rastrear-encomenda?deliveryStatus=${value}&label=${label}`

    window.open(
      path,
      "_blank"
    );
  },
    []);

  return (
    <Row xs={{ cols: 2 }} lg={{ cols: 4 }} className={`${styles.cardsStatus}`}>
      <>
        <Col xs={12} lg={6}>
          <div className={`${styles.card} ${styles.cardTotal}`}>
            <div className={styles.information}>
              <h3>Total de rotas diárias</h3>
              <h1>{data?.totalActivedRoute}</h1>
            </div>
            <div className={styles.informationImage}>
              <CurrentLocation />
            </div>
          </div>
        </Col>
        <Col className={styles.statusContainer} xs={12} lg={6}>
          <div
            className={`${styles.card} ${styles.cardStatus} ${styles.onTime}`}
            onClick={() => handleRedirect("10", "Entrega realizada")}
          >
            <div className={styles.cardStatusHeader}>
              <FiPackage size={30} color="#409e6a" />
              <p>Objetos entregues com sucesso</p>
            </div>
            <h3>{data?.DELIVERED_SUCCESSFULLY?.value}</h3>
          </div>
          <div
            className={`${styles.card} ${styles.cardStatus} ${styles.before}`}
            onClick={() => handleRedirect("5", "Objeto saiu para entrega")}
          >
            <div className={styles.cardStatusHeader}>
              <FiPackage size={30} color="#f5cb2b" />
              <p>Objetos em andamento</p>
            </div>
            <h3>{data?.OBJECTS_ON_ACTIVE_ROUTE?.value}</h3>
          </div>
          <div
            className={`${styles.card} ${styles.cardStatus} ${styles.pending}`}
            onClick={() => handleRedirect("4", "Objeto em trânsito") }
          >
            <div className={styles.cardStatusHeader}>
              <FiPackage size={30} color="#c1c1c1" />
              <p>Objetos pendentes</p>
            </div>
            <h3>{data?.PENDING_OBJECTS?.value}</h3>
          </div>
          <div
            className={`${styles.card} ${styles.cardStatus} ${styles.later}`}
            onClick={() => handleRedirect("13", "Não foi possível entregar o objeto")}
          >
            <div className={styles.cardStatusHeader}>
              <FiPackage size={30} color="#FF6B71" />
              <p>Objetos não entregues</p>
            </div>
            <h3>{data?.DELIVERED_UNSUCCESSFULLY?.value}</h3>
          </div>
        </Col>
      </>
    </Row>
  );
};

export { ChartBySla };
